import styled from "@emotion/styled/macro";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: start;
  padding-top: 0;
  padding-left: 32px
`;